// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  KeywordInfoResponseDTO,
  KeywordWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restDeletionHandler,
  restDetailsHandler,
  restListHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const keywordsUrl = baseUrl + "/keywords/";

export const requestGetKeywords = createEffect({
  handler: restListHandler<KeywordInfoResponseDTO>(keywordsUrl)
});
export const requestGetKeyword = createEffect({
  handler: restDetailsHandler<KeywordInfoResponseDTO>(keywordsUrl)
});
export const requestCreateKeyword = createEffect({
  handler: restCreationHandler<KeywordWriteRequestDTO, KeywordInfoResponseDTO>(
    keywordsUrl
  )
});
export const requestDeleteKeyword = createEffect({
  handler: restDeletionHandler<KeywordInfoResponseDTO>(keywordsUrl)
});
